interface IconProps {
  size?: number | string;
  color?: string;
  className?: string;
}

export function ChartIcon({ size = 24, color, className }: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 14 14"
      fill="currentColor"
      style={color ? { color } : undefined}
      className={className}
      aria-hidden="true"
    >
      <path d="M1.3125 1.53125C1.3125 1.16758 1.01992 0.875 0.65625 0.875C0.292578 0.875 0 1.16758 0 1.53125V10.9375C0 12.1461 0.978906 13.125 2.1875 13.125H13.3438C13.7074 13.125 14 12.8324 14 12.4688C14 12.1051 13.7074 11.8125 13.3438 11.8125H2.1875C1.70352 11.8125 1.3125 11.4215 1.3125 10.9375V1.53125ZM12.9336 4.62109C13.1906 4.36406 13.1906 3.94844 12.9336 3.69414C12.6766 3.43984 12.2609 3.43711 12.0066 3.69414L8.75273 6.94805L6.59258 4.78789C6.33555 4.53086 5.91992 4.53086 5.66563 4.78789L2.81641 7.62891C2.55938 7.88594 2.55938 8.30156 2.81641 8.55586C3.07344 8.81016 3.48906 8.81289 3.74336 8.55586L6.12227 6.17695L8.28242 8.33711C8.53945 8.59414 8.95508 8.59414 9.20937 8.33711L12.9336 4.62109Z" />
    </svg>
  );
}
